import {createAction} from '@reduxjs/toolkit';

import type {ServerThread} from '../types/threads';

export const markThreadManuallyUnread = createAction<{threadId: ServerThread['id']; lastViewedAt: ServerThread['last_viewed_at']}>(
    'threads/actions/markThreadManuallyUnread',
);
